function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "w"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M101.9,36.2c0,17.4-14.1,31.5-31.5,31.5C53.1,67.7,39,53.6,39,36.2 C39,18.8,53.1,4.8,70.5,4.8C87.8,4.8,101.9,18.8,101.9,36.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M140.4,176.3l-24.4-92.7c0,0,0-0.1,0-0.1c-0.8-4.1-4.4-7.1-8.6-7.1H33.6 c-4.2,0-7.8,3-8.6,7.1c0,0,0,0.1,0,0.1L0.5,176.3c-1.4,5.2,1.7,10.5,6.9,11.9c5.2,1.4,10.5-1.7,11.9-6.9l19.7-75v41.9l-19.2,72.9 H39v73.4c0,6.8,5.5,12.4,12.4,12.4c6.8,0,12.4-5.5,12.4-12.4l0,0v-73.3h13.4v73.3c0,6.8,5.5,12.4,12.4,12.4 c6.8,0,12.4-5.5,12.4-12.4c0,0,0,0,0,0v-73.3h19.2l-19.2-72.9v-42.1l19.7,75c1.4,5.2,6.7,8.3,11.9,6.9 C138.7,186.8,141.8,181.5,140.4,176.3L140.4,176.3z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "w"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M268.1,36.2c0,17.4-14.1,31.5-31.5,31.5c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5C254,4.8,268.1,18.8,268.1,36.2C268.1,36.2,268.1,36.2,268.1,36.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M306.6,176.4l-24.4-92.7c0,0,0-0.1,0-0.1c-0.8-4.1-4.4-7.1-8.6-7.1h-73.8 c-4.2,0-7.8,3-8.6,7.1c0,0,0,0.1,0,0.1l-24.4,92.7c-1.3,5.2,1.8,10.5,7,11.8c5.1,1.3,10.4-1.7,11.8-6.9l19.7-75v41.9L186,221.1 h19.2v73.4c0,6.8,5.5,12.4,12.4,12.4c6.8,0,12.4-5.5,12.4-12.4c0,0,0,0,0,0v-73.3h13.4v73.3c0,6.8,5.5,12.4,12.4,12.4 c6.8,0,12.4-5.5,12.4-12.4l0,0v-73.3h19.2l-19.2-72.9v-42.1l19.7,75c1.3,5.2,6.6,8.4,11.8,7.1c5.2-1.3,8.4-6.6,7.1-11.8 C306.6,176.5,306.6,176.4,306.6,176.4L306.6,176.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "w"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M426.2,35.8c0,17.4-14.1,31.5-31.5,31.5c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5l0,0C412.1,4.3,426.2,18.4,426.2,35.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M464.7,175.9l-24.4-92.7c0,0,0-0.1,0-0.1c-0.8-4.1-4.4-7.1-8.6-7.1h-73.8 c-4.2,0-7.8,3-8.6,7.1c0,0,0,0.1,0,0.1l-24.4,92.7c-1.4,5.2,1.7,10.5,6.9,11.9c5.2,1.4,10.5-1.7,11.9-6.9l19.7-75v41.9l-19.2,72.9 h19.2v73.4c0,6.8,5.6,12.4,12.4,12.4c6.8,0,12.3-5.5,12.4-12.4v-73.3h13.4v73.3c0,6.8,5.5,12.4,12.4,12.4s12.4-5.5,12.4-12.4l0,0 v-73.3h19.2l-19.2-72.9v-42.1l19.7,75c1.4,5.2,6.7,8.2,11.9,6.8C463,186.3,466.1,181,464.7,175.9L464.7,175.9z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "w"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M592.4,35.8c0,17.4-14.1,31.5-31.5,31.5c-17.4,0-31.5-14.1-31.5-31.5 c0-17.4,14.1-31.5,31.5-31.5C578.3,4.3,592.4,18.4,592.4,35.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M630.9,175.9l-24.4-92.7c0,0,0-0.1,0-0.1c-0.8-4.1-4.4-7.1-8.6-7.1H524 c-4.2,0-7.8,3-8.6,7.1c0,0,0,0.1,0,0.1L491,175.9c-1.4,5.2,1.7,10.5,6.9,11.9c5.2,1.4,10.5-1.7,11.9-6.9l19.7-75v41.9l-19.2,72.9 h19.2v73.4c0,6.8,5.5,12.4,12.4,12.4s12.4-5.5,12.4-12.4v-73.3h13.4v73.3c0,6.8,5.5,12.4,12.4,12.4s12.4-5.5,12.4-12.4v-73.3h19.2 l-19.2-72.9v-42.1l19.7,75c1.4,5.2,6.7,8.3,11.9,6.9C629.2,186.4,632.3,181.1,630.9,175.9L630.9,175.9L630.9,175.9z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M717.8,14.9c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8C711.2,0.2,717.8,6.8,717.8,14.9C717.8,14.9,717.8,14.9,717.8,14.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M724.6,33.8h-43.1c-2.5,0-4.6,2-4.6,4.6c0,0,0,0,0,0v44.8c0,2.5,1.9,4.6,4.4,4.8 c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1V44.1c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v92c0,3.1,2.3,5.7,5.4,6 c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V88h6.3v48.1c0,3.1,2.3,5.7,5.4,6c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V44.1 c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v39.2c0,2.5,1.9,4.6,4.4,4.8c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-45 C729.2,35.9,727.1,33.8,724.6,33.8z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M803.7,14.9c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8C797,0.2,803.7,6.8,803.7,14.9C803.7,14.9,803.7,14.9,803.7,14.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M810.4,33.8h-43.1c-2.5,0-4.6,2-4.6,4.6c0,0,0,0,0,0v44.8c0,2.5,1.9,4.6,4.4,4.8 c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1V44.1c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v92c0,3.1,2.3,5.7,5.4,6 c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V88h6.3v48.1c0,3.1,2.3,5.7,5.4,6c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V44.1 c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v39.2c0,2.5,1.9,4.6,4.4,4.8c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-45 C815,35.9,813,33.8,810.4,33.8z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M889.5,14.9c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8C882.9,0.2,889.5,6.8,889.5,14.9C889.5,14.9,889.5,14.9,889.5,14.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M896.3,33.8h-43.1c-2.5,0-4.6,2-4.6,4.6v44.8c0,2.5,1.9,4.6,4.4,4.8 c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1V44.1c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v92c0,3.1,2.3,5.7,5.4,6 c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V88h6.3v48.1c0,3.1,2.3,5.7,5.4,6c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4V44.1 c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v39.2c0,2.5,1.9,4.6,4.4,4.8c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-45 C900.8,35.9,898.8,33.8,896.3,33.8z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M720.1,182.7c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8C713.4,167.9,720.1,174.5,720.1,182.7C720.1,182.7,720.1,182.7,720.1,182.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M726.8,201.6h-43.1c-2.5,0-4.6,2-4.6,4.6c0,0,0,0,0,0v44.8c0,2.5,1.9,4.6,4.4,4.8 c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-39.3c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v92c0,3.1,2.3,5.7,5.4,6 c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4v-48.3h6.3v48.1c0,3.1,2.3,5.7,5.4,6c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4v-92.2 c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1V251c0,2.5,1.9,4.6,4.4,4.8c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-45 C731.4,203.6,729.4,201.6,726.8,201.6C726.8,201.6,726.8,201.6,726.8,201.6z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M805.9,182.7c0,8.2-6.6,14.8-14.8,14.8c-8.2,0-14.8-6.6-14.8-14.8 c0-8.2,6.6-14.8,14.8-14.8C799.3,167.9,805.9,174.5,805.9,182.7C805.9,182.7,805.9,182.7,805.9,182.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M812.7,201.6h-43.1c-2.5,0-4.6,2-4.6,4.6c0,0,0,0,0,0v44.8c0,2.5,1.9,4.6,4.4,4.8 c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-39.3c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1v92c0,3.1,2.3,5.7,5.4,6 c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4v-48.3h6.3v48.1c0,3.1,2.3,5.7,5.4,6c3.2,0.2,6-2.2,6.2-5.4c0-0.1,0-0.3,0-0.4v-92.2 c0-0.6,0.5-1.1,1.1-1.1l0,0c0.6,0,1.1,0.5,1.1,1.1V251c0,2.5,1.9,4.6,4.4,4.8c2.5,0.1,4.6-1.9,4.7-4.4c0,0,0-0.1,0-0.1v-45 C817.2,203.6,815.2,201.6,812.7,201.6C812.7,201.6,812.7,201.6,812.7,201.6z"
}));

function SvgW4M5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 901 310",
    enableBackground: "new 0 0 901 310",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW4M5);
export default __webpack_public_path__ + "static/media/w4-m5.6145e605.svg";
export { ForwardRef as ReactComponent };